import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import breakpoints from "../../../../assets/images/docs/breakpoints.png";
import syncedInteractions from "../../../../assets/images/docs/syncedinteractions.png";
import stylepanel from "../../../../assets/images/docs/elements/style.png";
import mediaEmulation from "../../../../assets/images/docs/media-emulation.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  breakpoints,
  syncedInteractions,
  stylepanel,
  mediaEmulation,
  React
};